import { render, staticRenderFns } from "./AppHeaderV2.vue?vue&type=template&id=33142d84&scoped=true"
import script from "./AppHeaderV2.vue?vue&type=script&lang=js"
export * from "./AppHeaderV2.vue?vue&type=script&lang=js"
import style0 from "./AppHeaderV2.vue?vue&type=style&index=0&id=33142d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33142d84",
  null
  
)

export default component.exports